export const ROLES = {
  SUPER_ADMIN: 'Super Admin',
  PRACTISE_ADMIN: 'Practice Admin',
  DEPT_ADMIN: 'Dept Admin',
  DOCTOR: 'Doctor',
  OTHER: 'Other',
  PATIENT: 'Patient'
};
